import React, { useEffect, useRef, useState } from 'react'
import WOW from 'wowjs';
function BannerTwo() {
    useEffect(() => {
        const wow = new WOW.WOW();
        wow.init();
    }, []);
    const textToCopyRef = useRef(null);
    const [copyMessageVisible, setCopyMessageVisible] = useState(false);

    const handleCopy = () => {
        if (!textToCopyRef.current) {
            console.error('Text input not found!');
            return;
        }

        // Select the text for compatibility
        textToCopyRef.current.select();
        textToCopyRef.current.setSelectionRange(0, 99999);

        // Copy the text to the clipboard
        navigator.clipboard
            .writeText(textToCopyRef.current.value)
            .then(() => {
                // Show copy message
                setCopyMessageVisible(true);
                setTimeout(() => {
                    setCopyMessageVisible(false);
                }, 2000);
            })
            .catch((err) => console.error('Failed to copy text: ', err));
    };
    return (
        <>
            {/* Banner area Start */}
            <section id="home" className="rts-banner-area area-two">
                <div className="banner-hero">
                    <img
                        className="wow scaleIn"
                        data-wow-delay=".8s"
                        data-wow-duration="1s"
                        src="assets/images/banner/banner-hero-02.svg"
                        width={596}
                        alt=""
                    />
                </div>
                <div className="shape-area">
                    <img
                        className="wow fadeIn"
                        data-wow-delay="1s"
                        data-wow-duration="2s"
                        src="assets/images/banner/coin-01.svg"
                        width={63}
                        alt=""
                    />
                    <img
                        className="wow fadeIn"
                        data-wow-delay="1s"
                        data-wow-duration="2s"
                        src="assets/images/banner/coin-01.svg"
                        width={63}
                        alt=""
                    />
                    <img
                        className="wow fadeIn"
                        data-wow-delay="1s"
                        data-wow-duration="2s"
                        src="assets/images/banner/coin-01.svg"
                        width={47}
                        alt=""
                    />
                    <img
                        className="wow fadeIn"
                        data-wow-delay="1s"
                        data-wow-duration="2s"
                        src="assets/images/banner/coin-02.svg"
                        width={39}
                        alt=""
                    />
                    <img
                        className="wow fadeIn"
                        data-wow-delay="1s"
                        data-wow-duration="2s"
                        src="assets/images/banner/coin-02.svg"
                        width={39}
                        alt=""
                    />
                </div>
                <div className="container">
                    <div className="row">
                        <div className="col-lg-7">
                            <div className="banner-wrapper-one">
                                <div className="section-title-area">
                                    <p
                                        className="sub-title wow fadeInUp"
                                        data-wow-delay=".2s"
                                        data-wow-duration="2s"
                                    >
                                        Laugh Out Loud, Share the Joy
                                    </p>
                                    <h1
                                        className="section-title wow fadeInUp"
                                        data-wow-delay=".5s"
                                        data-wow-duration="2s"
                                    >
                                        Discover What Makes Us Special
                                    </h1>
                                </div>
                                <p
                                    className="desc wow fadeInUp"
                                    data-wow-delay=".8s"
                                    data-wow-duration="2s"
                                >
                                    Dive into a world where creativity meets humor, and every click
                                    brings a smile. With our easy-to-use meme creator, you can design
                                    hilarious memes that capture your unique style. Not a creator? No
                                    worries!
                                </p>
                                <div
                                    className="copy-text-area animate__animated animate__fadeInUp"
                                    style={{ animationDelay: '1.4s', animationDuration: '2s' }}
                                >
                                    <div className="inner">
                                        <div className="input-wrapper with-after">
                                            <input
                                                type="text"
                                                id="textToCopy"
                                                ref={textToCopyRef}
                                                defaultValue="0xe471der3c127466908c2ccdc43521c8315b87fd369d605"
                                                readOnly
                                            />
                                        </div>
                                        <div className="button with-after">
                                            <button className="rts-btn bg-white" id="copyButton" onClick={handleCopy}>
                                                Copy
                                            </button>
                                        </div>
                                    </div>
                                    {copyMessageVisible && (
                                        <p id="copyMessage" className="mt--10" style={{ color: 'green' }}>
                                            Text copied!
                                        </p>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            {/* Banner area end */}
        </>

    )
}

export default BannerTwo